/* eslint-disable */
import React from 'react';

import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Phone from './Icons/Callstatic';
import { BannerBtn } from './ButtonUtils';

const PhoneBannerBtn = ({ state, classes }) => {
    return (
        <BannerBtn
            state={state}
            classes={classes}
            icon={<Phone name="phone" />}
            title="Call Support"
            buttonId='toolbar-call-support-button'
            aria='phone'
        >
            <Typography className={classes.popoverTextHeader}>
                CALL US
            </Typography>
            <br />

            <Typography className={classes.popoverTextBody}>
                Get technical support or help navigating the
                experience.
            </Typography>
            <br />

            <Link
                href={`tel:+1-888-358-8490}`}
                className={classes.popoverTelephoneLink}
            >
                1-888-358-8490
            </Link>
        </BannerBtn>
    );
};
export default PhoneBannerBtn;
